import { apiClient } from '../client';
import type {
  ROIMetricsResponse,
  ExecutiveDashboardResponse,
  HospitalizationAvoidedResponse,
  MarkHospitalizationAvoidedRequest,
} from '@/types/analytics.types';
import type { PaginatedResponse } from '@/api/types/pagination.types';

const BASE_URL = '/v1/analytics';

export interface DateRangeParams {
  startDate: string;
  endDate: string;
}

export interface PaginationParams {
  page?: number;
  size?: number;
  sort?: string;
}

/**
 * Calcula métricas de ROI para o período especificado.
 */
export async function getROI(params: DateRangeParams): Promise<ROIMetricsResponse> {
  const response = await apiClient.get<ROIMetricsResponse>(`${BASE_URL}/roi`, {
    params,
  });
  return response.data;
}

/**
 * Retorna dashboard executivo completo.
 */
export async function getExecutiveDashboard(
  params: DateRangeParams
): Promise<ExecutiveDashboardResponse> {
  const response = await apiClient.get<ExecutiveDashboardResponse>(
    `${BASE_URL}/executive-dashboard`,
    { params }
  );
  return response.data;
}

/**
 * Lista internações evitadas com paginação.
 */
export async function getHospitalizationsAvoided(
  params?: PaginationParams
): Promise<PaginatedResponse<HospitalizationAvoidedResponse>> {
  const response = await apiClient.get<PaginatedResponse<HospitalizationAvoidedResponse>>(
    `${BASE_URL}/hospitalizations-avoided`,
    { params }
  );
  return response.data;
}

/**
 * Marca uma internação como evitada.
 */
export async function markHospitalizationAvoided(
  id: string,
  request: MarkHospitalizationAvoidedRequest
): Promise<HospitalizationAvoidedResponse> {
  const response = await apiClient.post<HospitalizationAvoidedResponse>(
    `${BASE_URL}/hospitalizations/${id}/mark-avoided`,
    request
  );
  return response.data;
}
